import { CookieConfig } from "@/interface/config.types";
import packageJson from "../../package.json";

// Cookie related configurations
export const COOKIE_CONFIG: CookieConfig = {
  loggedIn: `${packageJson.name}_isLoggedIn`,
  profile: `${packageJson.name}_profile`,
  version: `${packageJson.name}_version`,
} as const;

// App related configurations
export const APP_CONFIG = {
  name: process.env.NEXT_PUBLIC_APP_NAME || "Your App Name",

  description:
    process.env.NEXT_PUBLIC_APP_DESCRIPTION || "Your app description goes here",
  keywords: process.env.NEXT_PUBLIC_APP_KEYWORDS?.split(",") || [
    "keyword1",
    "keyword2",
  ],
  environment: process.env.NODE_ENV || "development",
} as const;

// API related configurations
export const API_CONFIG = {
  frontendApiKey: process.env.NEXT_PUBLIC_FRONTEND_API_KEY || "",
  backendApiKey: process.env.NEXT_PUBLIC_BACKEND_API_KEY || "",
  cmsApiKey: process.env.NEXT_PUBLIC_CMS_API_KEY || "",
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "http://localhost:3000/api/v1",
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:3000",
  pollingInterval:
    Number(process.env.NEXT_PUBLIC_VERSION_POLLING_INTERVAL) || 2 * 60 * 1000, // Default to 2 minutes
  postponeDelay:
    Number(process.env.NEXT_PUBLIC_VERSION_POSTPONE_DELAY) || 2 * 60 * 1000, // Default to 2 minutes
  enablePolling:
    process.env.NEXT_PUBLIC_VERSION_ENABLE_POLLING === "true" || false, // Defaults to false
} as const;
